import React, { ComponentType } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorPage from '../../../../ErrorPage/index'
import { ERROR_TYPE_500 } from '../../../../ErrorPage/types'

export type CommunityErrorBoundaryOuterProps = {
  history: { push?: (path: string) => void }
  location: { pathname?: string; search?: string }
}

/**
 * Wraps a community route page so render errors show the standard 500 ErrorPage.
 */
function withCommunityErrorBoundary<P extends CommunityErrorBoundaryOuterProps> (
  WrappedComponent: ComponentType<P>,
): ComponentType<P> {
  function WithCommunityErrorBoundary (props: P) {
    return (
      <ErrorBoundary
        fallback={(
          <ErrorPage
            history={props.history}
            location={props.location}
            code={ERROR_TYPE_500}
          />
        )}
      >
        <WrappedComponent {...props} />
      </ErrorBoundary>
    )
  }

  const wrappedName = WrappedComponent.displayName || WrappedComponent.name || 'Component'
  WithCommunityErrorBoundary.displayName = `withCommunityErrorBoundary(${wrappedName})`

  return WithCommunityErrorBoundary
}

export { withCommunityErrorBoundary }
export default withCommunityErrorBoundary
